/* This is generated code, don't alter */
var marker_type;
(function (marker_type) {
    marker_type[marker_type["DOT"] = 0] = "DOT";
    marker_type[marker_type["X"] = 1] = "X";
    marker_type[marker_type["PLUS"] = 2] = "PLUS";
    marker_type[marker_type["ASTERISK"] = 3] = "ASTERISK";
    marker_type[marker_type["RING"] = 4] = "RING";
    marker_type[marker_type["SQUARE"] = 5] = "SQUARE";
    marker_type[marker_type["TRIANGLE"] = 6] = "TRIANGLE";
})(marker_type || (marker_type = {}));
const marker_typeCount = 7;
export { marker_type, marker_typeCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapmarker_type = new Int32Array([4]);
let prefixSumAddressmarker_type = new Uint32Array([0, 10, 16, 19, 27, 33, 38, 48]);
let slotMapmarker_type = new Int32Array([6, 4, 1, 5, 2, 0, 3]);
let encodedDatamarker_type = (new TextEncoder()).encode(".TRIANGLE..RING..X..SQUARE..PLUS..DOT..ASTERISK.");
let marker_typeSearch = new MinimalPerfectHash(gMapmarker_type, prefixSumAddressmarker_type, slotMapmarker_type, encodedDatamarker_type);
export { marker_typeSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function marker_typeDeserializeStep(input, cursor, endCursor) {
    return parser.extract(marker_typeSearch, input, cursor, endCursor);
}
